import {String} from 'aws-sdk/clients/cloudwatchevents';
import {useAccountContext} from '../lib/accountContext';

export const useAccountName = (): String => {
  const account = useAccountContext();
  return account?.publicBusinessDetails?.companyName || '';
};
